/** Sort modes used by the Inicio (Clips) reels feed placeholder algorithm. */
export const FEED_SORT_MODES = ['recent', 'viewed', 'liked', 'random'];

/** Uniform pick — one of four modes per fresh page load. */
export function pickRandomFeedSort() {
  return FEED_SORT_MODES[Math.floor(Math.random() * FEED_SORT_MODES.length)];
}

/** Stable seed so random order stays fixed for the lifetime of a feed load. */
export function createFeedShuffleSeed() {
  return Math.floor(Math.random() * 0x100000000);
}

/** Fisher–Yates shuffle with a deterministic PRNG (mulberry32). */
export function seededShuffle(items, seed) {
  const result = [...items];
  let state = seed >>> 0;

  const next = () => {
    state = (state + 0x6d2b79f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };

  for (let i = result.length - 1; i > 0; i -= 1) {
    const j = Math.floor(next() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }

  return result;
}
